import React, { createContext, useState, useEffect, useContext } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import { Navigate, useNavigate } from "react-router-dom";
import { getOffsetLeft } from "@mui/material";
//
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // useEffect(() => { checkToken(); }, []);
  const navigate = useNavigate();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const [userResponse, setUserResponse] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [getToken, setToken] = useState(null);

  useEffect(() => {
    // const details = localStorage.getItem("UserDetails");
    // if (details && isLoading === true) {
    //   const value = JSON.parse(details);
    //   setUserResponse(value);
    //   //   setIsLoading(false)
    const initializeAuth = async () => {
      const token = localStorage.getItem("Token");
      setToken(token);
      if (token) {
        try {
          setIsAuthenticated(true);

          // Add logic to check token expiration if needed
          // For now, assuming token is valid
        } catch (error) {
          console.error("Error decoding token:", error);
        }
      } else {
        // Token not found, set as not authenticated
        setIsAuthenticated(false);
        setUser(null);
        // Redirect to login page if no token is found
        navigate("/login", { replace: true });
      }

      setIsLoading(false);
    };
    initializeAuth();
    // }
  }, []);
  // const navigate=useNavigate();

  const checkToken = (token) => {
    // const token = localStorage.getItem("authToken");

    if (!token) {
      setIsAuthenticated(false);
      setUser(null);
      logout();
      return;
    } else {
      setIsAuthenticated(true);
      return;
    }
  };

  const login = async (data) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/login`, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      const token = response.data?.result?.accessToken;
      const details = response?.data?.result?.details;
      localStorage.setItem("Token", token);
      setIsAuthenticated(true);
      localStorage.setItem("userName", details?.name);
      localStorage.setItem("UserDetails", JSON.stringify(details));
      setUserResponse(details);
      setIsLoading(true);
      //   userResponse(details);
      // checkToken(token);
      return response;
    } catch (error) {
      return error;
    }
    // localStorage.setItem("authToken", token);
    // checkToken();
  };

  //   const userResponse = (details) => {
  //     return details;
  //   };

  const logout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("userName");
    setIsAuthenticated(false);
    setUser(null);
    navigate("/login");
    return;
    // navigate('/login')
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, login, logout, userResponse }}
    >
      {children}
      {/* {getToken===null ?  <Navigate to="/login" /> : children} */}
    </AuthContext.Provider>
  );
};

//  AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
